import React from 'react';
import { MapPin, Home, Heart, Shield, Building2 } from 'lucide-react';
import img1 from '../../assets/renders/VILLAS0.jpeg';
import img2 from '../../assets/renders/CLUBHOUSE06.jpeg';
import img3 from '../../assets/renders/livin.jpeg';
import img4 from '../../assets/renders/bed10.jpeg';
import { Link } from 'react-router-dom';

const ProjectOverview = () => {
  return (
    <>      
      <div className="pt-16 sm:pt-28 px-3 sm:px-6 md:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          
          {/* Header Section */}
          {/* <div className="text-center mb-20">
            <h2 className="text-4xl font-medium text-[var(--primarycolor)] text-gray-900 mb-6 tracking-tight">
              Featured Project
            </h2>
            <div className="w-24 h-px mx-auto mb-8" style={{ backgroundColor: 'var(--primarycolor)' }}></div>
          </div> */}

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
            
            {/* Left Content */}
            <div className="space-y-8">
                <div>
                <div className={'inline-flex items-center gap-2 px-4 py-2 backdrop-blur-md rounded-full text-xs font-medium mb-4 border '}
                   style={{ 
                     color: 'var(--primarycolor)',
                     borderColor: 'var(--primarycolor)'
                   }}>
                <Building2 size={14} />
                Featured Project
              </div>
                <h3 className="text-3xl md:text-4xl text-[var(--primarycolor)] tracking-tight mb-4">
                    Dignity
                </h3>
                <div className="flex flex-wrap items-center gap-4 mb-4">
                  <div className="flex items-center gap-2 text-gray-600">
                    <MapPin className="w-4 h-4" />
                    <span className="text-sm">Chamal Road, Malapuram, Thamarasserry, Calicut</span>
                  </div>
                  <div className="flex items-center gap-3 py-1 transition-colors duration-300">
                    <Shield size={24} className="text-[var(--primarycolor)] flex-shrink-0" />
                    <div className="flex flex-col">
                      <span className="text-[10px] uppercase font-bold text-gray-400 leading-none mb-1 tracking-wider">RERA Registered</span>
                      <span className="text-sm sm:text-base font-bold text-gray-900 tabular-nums">K-RERA/PRJ/KKD/041/2026</span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Nestled in nature's embrace, Dignity Thamarasserry overlooks the majestic Western Ghats. 
                  This serene and tranquil location offers the perfect blend of peaceful living and urban 
                  connectivity, with wide roads and excellent transport facilities.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Experience a landscaped community where every morning brings breathtaking views and 
                  every evening offers peaceful moments in nature's sanctuary.
                </p>
                {/* CTA Section */}
                <div className="mt-4 group">
                    <Link to='/projects'><button 
                        className="px-5 py-3 text-sm text-white font-medium tracking-wide rounded-full uppercase transition-all duration-300 bg-[var(--primarycolor)] group-hover:bg-red-900 flex items-center gap-2 "
                    >
                        View Details
                        <svg className="w-4 h-4 group-hover:translate-x-1 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </button></Link>
                </div>

                {/* <div className="relative mt-6 inline-block group"> */}
                  {/* <div className="absolute -inset-1 bg-gradient-to-r from-red-200 to-red-100 rounded-full blur opacity-60 group-hover:opacity-80 transition-opacity"></div> */}
                  {/* <div className="relative flex items-center gap-3 px-7 py-3 bg-white/90 rounded-full border border-red-200 ">
                    <svg 
                      className="w-5 h-5 text-[var(--primarycolor)] animate-pulse" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                      />
                    </svg>
                    <span className="text-lg font-bold bg-gradient-to-r from-[var(--primarycolor)] to-red-700 bg-clip-text text-transparent tracking-wide">
                      COMING SOON
                    </span>
                    <div className="w-2 h-2 bg-[var(--primarycolor)] rounded-full animate-ping"></div>
                  </div>
                </div> */}

              </div>

              {/* Living Options */}
              <div className="grid grid-cols-2 gap-1 sm:gap-3">
                <div className="text-center p-4 border border-gray-100 rounded-lg">
                  <div className="w-12 h-12 rounded-full border-2 border-gray-200 mx-auto mb-4 flex items-center justify-center">
                    <Home className="w-5 h-5 text-gray-700" />
                  </div>
                  <h5 className="font-medium text-gray-900 mb-2">Independent Living</h5>
                  <p className="text-sm text-gray-600">Freedom with access to services</p>
                </div>
                
                <div className="text-center p-4 border border-gray-100 rounded-lg">
                  <div className="w-12 h-12 rounded-full border-2 border-gray-200 mx-auto mb-4 flex items-center justify-center">
                    <Heart className="w-5 h-5 text-gray-700" />
                  </div>
                  <h5 className="font-medium text-gray-900 mb-2">Assisted Living</h5>
                  <p className="text-sm text-gray-600">Daily care and medication support</p>
                </div>
              </div>
            </div>

            {/* Right Images Grid */}
            <div className="grid grid-cols-2 gap-2 sm:gap-4">
              <div className="space-y-2 sm:space-y-4">
                <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                  <img 
                    src={img1} 
                    alt="Modern senior living villa"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden">
                  <img 
                    src={img2} 
                    alt="Western Ghats landscape view"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              <div className="space-y-2 sm:space-y-4">
                <div className="aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden">
                  <img 
                    src={img3} 
                    alt="Wellness center interior"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                  <img 
                    src={img4} 
                    alt="Landscaped garden and community area"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectOverview;